import { cx } from '@flowus/common/cx';
import type { FC } from 'react';

export const ChartLine: FC<{ className?: string }> = ({ className }) => {
  return <div className={cx('bg-grey7 w-full h-px', className)} />;
};
